import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import {
  createAppProducts,
  getAppProducts,
  updateAppProducts,
} from "../../../apis/AppProductsApi";
import { AddProductsScheme } from "../../../Validations/AppProductsValidation";
import { useParams, useNavigate } from "react-router-dom";
import { uploadImageServer } from "../../../apis/newsApi";
import langauge from "../../../lib/common/languages.json";

export default function AddAppProducts() {
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [addProducts, setAddProducts] = useState({
    name: "",
    description: "",
    crmProductId: "",
    minAmount: "",
    heading_1: "",
    heading_2: "",
    heading_3: "",
    title_1: "",
    title_2: "",
    title_3: "",
    zone: "",
    image: "",
    language: "",
    sort: "",
  });

  const Navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    console.log(id, "iddddd in edit");
    if (id) {
      setEditLoading(true);
      editProducts(id);
    }
  }, [id]);
  const editProducts = async (id) => {
    setEditLoading(true);
    try {
      const res = await getAppProducts(id);
      console.log(res.result, "resr rersrersrersrrerrs");
      console.log(res);
      if (res) {
        setAddProducts({
          name: res?.result?.name,
          description: res?.result?.description,
          crmProductId: res?.result?.crmProductId,
          minAmount: res?.result?.minAmount,
          heading_1: res?.result?.heading_1,
          heading_2: res?.result?.heading_2,
          heading_3: res?.result?.heading_3,
          title_1: res?.result?.title_1,
          title_2: res?.result?.title_2,
          title_3: res?.result?.title_3,
          zone: res?.result?.zone,
          image: res?.result?.image,
          language: res?.result?.language,
          sort: res?.result?.sort,
        });
        setEditLoading(false);
      }
    } catch (error) {
      console.error("Error fetching faqs:", error);
    } finally {
      setLoading(false);
    }
  };
  const formik = useFormik({
    initialValues: addProducts,
    enableReinitialize: true,
    validationSchema: AddProductsScheme,
    onSubmit: async (values) => {
      console.log(values, "checking values");
      try {
        setLoading(true);
        console.log(values, "values categories");
        let res;
        if (id) {
          res = await updateAppProducts(id, values);
        } else {
          res = await createAppProducts({ ...values, type: "document" });
          console.log(res);
          //   setSuccess(true);
        }
        setLoading(false);
        Navigate("/prod_list");
        // setMessage(res.result.message);
        formik.resetForm();
      } catch (error) {
        console.error("Error submitting form:", error);
        setLoading(false);
      }
    },
  });
  const backClick = () => {
    Navigate("/prod_list");
  };

  const uploadFile = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    const path = await uploadImageServer(formData);
    // console.log({ fileName: path.path });
    if (path) {
      formik.setFieldValue("image", path.path);
    }
  };
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <i
              className="fas fa-arrow-left"
              style={{
                marginRight: "30px",
                fontSize: "20px",
                cursor: "pointer",
              }}
              onClick={backClick}
            />

            <div className="my-3 p-3 bg-body rounded shadow-sm">
              <h3>{id ? "Edit" : "Add"} Product</h3>

              {editLoading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "50px", padding: "7px 30px" }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Title <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.name && formik.touched.name && (
                      <span className="text-danger">{formik.errors.name}</span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Crm Id <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="crmProductId"
                      value={formik.values.crmProductId}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.crmProductId &&
                      formik.touched.crmProductId && (
                        <span className="text-danger">
                          {formik.errors.crmProductId}
                        </span>
                      )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Description <span className="text-danger">*</span>
                    </label>

                    <textarea
                      className="form-control"
                      name="description"
                      placeholder="Enter description"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      rows={4}
                    />

                    {formik.errors.description &&
                      formik.touched.description && (
                        <span className="text-danger">
                          {formik.errors.description}
                        </span>
                      )}
                  </div>

                  <div className="input-block">
                    <label className="col-form-label">
                      Image <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      name="image"
                      accept="image/*"
                      onChange={uploadFile}
                      onBlur={formik.handleBlur}
                      placeholder="Upload File"
                      style={{ width: "250px" }}
                    />
                    {formik.errors.image && formik.touched.image && (
                      <span className="text-danger">{formik.errors.image}</span>
                    )}
                    {formik.values.image && (
                      <img src={formik.values.image} width={300} />
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Minimum Amount <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="minAmount"
                      value={formik.values.minAmount}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.minAmount && formik.touched.minAmount && (
                      <span className="text-danger">
                        {formik.errors.minAmount}
                      </span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Heading 1<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="heading_1"
                      value={formik.values.heading_1}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.heading_1 && formik.touched.heading_1 && (
                      <span className="text-danger">
                        {formik.errors.heading_1}
                      </span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Title 1<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="title_1"
                      value={formik.values.title_1}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.title_1 && formik.touched.title_1 && (
                      <span className="text-danger">
                        {formik.errors.title_1}
                      </span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Heading 2 <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="heading_2"
                      value={formik.values.heading_2}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.heading_2 && formik.touched.heading_2 && (
                      <span className="text-danger">
                        {formik.errors.heading_2}
                      </span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Title 2<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="title_2"
                      value={formik.values.title_2}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.title_2 && formik.touched.title_2 && (
                      <span className="text-danger">
                        {formik.errors.title_2}
                      </span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Heading 3<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="heading_3"
                      value={formik.values.heading_3}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.heading_3 && formik.touched.heading_3 && (
                      <span className="text-danger">
                        {formik.errors.heading_3}
                      </span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Title 3<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="title_3"
                      value={formik.values.title_3}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.title_3 && formik.touched.title_3 && (
                      <span className="text-danger">
                        {formik.errors.title_3}
                      </span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Zone<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="zone"
                      value={formik.values.zone}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <option value="">Select Zone</option>
                      <option value="Real Estate">Real Estate</option>
                      <option value="Utilities">Utilities</option>
                      <option value="Land & Agri">Land & Agri</option>
                    </select>
                    {formik.errors.zone && formik.touched.zone && (
                      <span className="text-danger">{formik.errors.zone}</span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Sort<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="sort"
                      value={formik.values.sort}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.sort && formik.touched.sort && (
                      <span className="text-danger">{formik.errors.sort}</span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">Language *</label>

                    <select
                      className="form-select"
                      name="language"
                      value={formik.values.language}
                      onChange={formik.handleChange}
                      // onBlur={formik.values.language}
                    >
                      <option value="">Select Language</option>

                      {langauge.map((lang) => (
                        <option key={lang.code} value={lang.code}>
                          {lang.label}
                        </option>
                      ))}
                    </select>
                    {formik.errors.language && formik.touched.language && (
                      <span className="text-danger">
                        {formik.errors.language}
                      </span>
                    )}
                  </div>

                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "50px", padding: "7px 30px" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <button className="btn btn-primary" type="submit">
                      {id ? "Update" : "Submit"}
                    </button>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
